export default "__VITE_ASSET__BQzSOPG3__"